"use strict"
;(() => {
  const mainCollection = document.querySelectorAll(".Main-Collection")

  mainCollection.forEach((element) => {
    const slider = element.querySelector(".Main-Collection__swiper")
    const swiperSlides = Array.from(element.querySelectorAll(".swiper-slide"))
    const activeSlide = element.querySelector(".swiper-slide .collection__filter-link.is-active")
    let slideIndex = 0

    if (activeSlide) {
      slideIndex = swiperSlides.indexOf(activeSlide.parentElement)
    }

    // swiper initialize
    new Swiper(slider, {
      initialSlide: slideIndex,
      grabCursor: true,
      slidesPerView: "auto",
      centerInsufficientSlides: true,
      scrollbar: {
        el: element.querySelector(".swiper-scrollbar"),
      },
      navigation: {
        prevEl: element.querySelector(".swiper-button-prev"),
        nextEl: element.querySelector(".swiper-button-next"),
      },
      breakpoints: {
        1: {
          slidesPerView: 3.6,
        },
        480: {
          slidesPerView: 4.5,
        },
        768: {
          spaceBetween: 6,
        },
        1024: {
          slidesPerView: 8,
        },
      },
    })
  })
})()

